import gql from 'graphql-tag';

export const query = gql`
  query Notes($prospectId: ID!) {
    applicationNotes(prospectId: $prospectId) {
      nodes {
        id
        content
        createdUser
        createdDate
        createdUserId
      }
    }
  }
`;
